<template>
    <div class="historico-inativacao">
        <ContainerTitle icon="paper" title="Histórico de inativação"/>

        <HistoricoInativacaoFilter @filter-historico-inativacao="filtrar" />
        <HistoricoInativacaoList :rows="rows"/>

        <ModalAlert id="historico-inativacao-list-vazio">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Essa pesquisa não possui histórico de inativação.
        </ModalAlert>
        
        <PaginationTable :page="page" :totalPages="result.totalPages" :totalItens="result.totalItens" @changePage="changePage" />
    </div>
</template>
<script>

import HistoricoInativacaoFilter from './components/HistoricoInativacaoFilter.vue'
import  HistoricoInativacaoList from './components/HistoricoInativacaoList.vue'
import ModalAlert from "../../../../commons/ModalAlert.vue"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";
import { formateTipo, formateDate, formateHours } from "./../../../../../util/BeneficiarioUtils.js";

export default {
    name: 'HistoricoInativacao',
    components: {
       HistoricoInativacaoList,
       HistoricoInativacaoFilter,
       DynamicIcon,
       ModalAlert,
       PaginationTable,
       ContainerTitle
    },
	data() {
		return {
            rows: [],
            result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			},
            historicoIdEdition: null,
			historicoIdDeletion: null,
			historicoPerfisEdition: null,
			showModalForm: null,
			page: 1,
			filterForm: {},
            lastFilter: null
		}
	},
    methods: {
		changePage( page ){
			this.page = page
			this.filtrar( this.lastFilter )	
		},
        filtrar(formFilter) 
        {
            if(formFilter) {
                this.lastFilter = {...formFilter}
            }

			let filter = {
				page: this.page,
                size: this.size,
                tipo: this.lastFilter?.tipo, 
                nome: this.lastFilter?.name, 
                ano : this.lastFilter?.ano, 
                empresa : this.lastFilter?.empresa, 
			}

			BeneficiarioImportacaoResource.consultarHistoricoInativo(filter, {showLoader: true})
			.then((result) => {
                if(!Array.isArray(result.list))
                {
                    this.rows = [];
                }
                
                if(!result.list.length)
                {
                    this.$bvModal.show("historico-inativacao-list-vazio");
                }

                this.result = result

                this.rows = result.list.map( elem =>  { 
                    return {
                        ...elem.beneficiario,
                        nome: elem.beneficiario.nome,
                        tipo: formateTipo(elem.beneficiario.tipoId),
                        data: formateDate(elem.beneficiario.dataInativo),
                        hora: formateHours(elem.beneficiario.dataInativo),
                        responsavel: elem.nomeResponsavel,
                        empresa: elem.beneficiario.razaoSocial
                    }
                })
			})
            .catch(()=>{
                this.rows = []
            })
		}
    },
    mounted() {
        this.filtrar(this.filterForm);
    }
}

</script>

<style scoped>
.historico-importacao {
	justify-content: space-between;
    color: #707070;
	font-size: 18px;
	text-align: left;
	padding: 20px 5px 20px 5px;
    background-color: #fff;
}
</style>